export default __webpack_public_path__ + "static/media/2.5cad5955.jpg";